export default "__VITE_ASSET__NGc7gpPx__"